import { Box, Paper, Select, Stack, Text } from '@mantine/core';
import { TInvoicingCompany } from '@/models/renewals';

interface IssuerSectionProps {
  companies: TInvoicingCompany[];
  selectedCompanyId: number | null;
  onCompanyChange: (id: number | null) => void;
  isLoading?: boolean;
}

export default function IssuerSection({
  companies,
  selectedCompanyId,
  onCompanyChange,
  isLoading,
}: IssuerSectionProps) {
  const selectedCompany =
    companies.find((c) => c.id === selectedCompanyId) || null;

  const companyOptions = companies.map((c) => ({
    value: String(c.id),
    label: `${c.name} (${c.countryCode})`,
  }));

  return (
    <Paper p="md" withBorder>
      <Text size="xs" fw={600} c="dimmed" mb="xs" tt="uppercase">
        Issuing Company
      </Text>

      <Stack gap="xs">
        <Select
          size="xs"
          label="Select Company"
          placeholder={
            isLoading ? 'Loading companies...' : 'Select issuing company'
          }
          value={selectedCompanyId ? String(selectedCompanyId) : null}
          onChange={(value) => onCompanyChange(value ? Number(value) : null)}
          data={companyOptions}
          disabled={isLoading}
          clearable
        />

        {selectedCompany && (
          <Box pt="xs">
            <Text size="sm" fw={500}>
              {selectedCompany.name}
            </Text>
            {selectedCompany.vatNumber && (
              <Text size="xs" c="dimmed">
                VAT: {selectedCompany.vatNumber}
              </Text>
            )}
            {selectedCompany.registrationNumber && (
              <Text size="xs" c="dimmed">
                Reg #: {selectedCompany.registrationNumber}
              </Text>
            )}
            <Text size="xs" c="dimmed">
              {selectedCompany.legalAddress}
            </Text>
          </Box>
        )}
      </Stack>
    </Paper>
  );
}
